import {Avatar, Typography, makeStyles} from '@material-ui/core';
import Warning from '@material-ui/icons/Warning';

const useStyles = makeStyles(theme => ({
	errorAlert: {
		padding: theme.spacing(1, 1, 4),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center'
	},
	avatar: {
		margin: theme.spacing(1, 1, 5),
		backgroundColor: theme.palette.error.main,
		width: theme.spacing(7),
		height: theme.spacing(7)
	},
	btn: {
		marginTop: theme.spacing(5)
	}
}));

const ErrorAlert = ({text}: {text: string | null}) => {
	const classes = useStyles();
	return (
		<div className={classes.errorAlert}>
			<Avatar className={classes.avatar}>
				<Warning />
			</Avatar>
			<Typography component="h1" variant="h5">
				{text}
			</Typography>
		</div>
	);
};

export default ErrorAlert;
